/* Potent Speed Radar v1.4. Native Shopify product form; no new cart or tracking SDK.
   A custom element scopes listeners and supports Theme Editor section re-renders. */
(() => {
  'use strict';
  if (customElements.get('potent-speed-radar')) return;
  class PotentSpeedRadar extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._abort = new AbortController();
      this._observers = [];
      this._buyState = 'idle';
      this._pastBuy = false;
      this._atFinal = false;
      this._isPreview = this.dataset.preview === 'true';
      this.form = this.querySelector('[data-main-form]');
      this.cartMsgs = [...this.querySelectorAll('[data-cart-msg]')];
      this.qty = this.form?.querySelector('[name="quantity"]');
      this.variant = this.form?.querySelector('[name="id"]');
      this.sticky = this.querySelector('[data-sticky]');
      this.dialog = this.querySelector('[data-preview-dialog]');
      this.mediaQuery = matchMedia('(max-width: 760px)');
      this.listen(this, 'click', e => this.onAddClick(e), true);
      this.listen(this, 'click', this.onClick.bind(this));
      this.listen(this, 'keydown', this.onKeys.bind(this));
      this.listen(this, 'change', this.onChange.bind(this));
      this.listen(window, 'pageshow', () => this.endBusy(null));
      this.listen(window, 'pagehide', () => this.clearBuyTimers());
      this.listen(this.mediaQuery, 'change', () => this.updateSticky());
      if (this.form) this.listen(this.form, 'submit', e => this.onSubmit(e));
      if (this.dialog) {
        this.listen(this.dialog, 'close', () => {
          this.updateSticky();
          this._dialogTrigger?.focus({preventScroll: true});
        });
        this.listen(this.dialog, 'click', e => { if(e.target === this.dialog) this.dialog.close(); });
      }
      this.querySelectorAll('[data-preview-enable]').forEach(b => b.disabled = false);
      this.querySelectorAll('[data-tabs]').forEach(t => {
        t.setAttribute('role', 'tablist');
        t.querySelectorAll('[data-tab]').forEach(b => b.setAttribute('role','tab'));
      });
      this.querySelectorAll('[data-film] video').forEach(v => {
        this.listen(v, 'error', () => {
          const message = v.closest('[data-film]')?.querySelector('[data-video-error]');
          if (message) message.hidden = false;
        });
      });
      this.updateVariant();
      this.setupGift();
      this.setupReviews();
      this.querySelectorAll('[data-clip-toggle]').forEach(b=>this.listen(b,'click',ev=>{ev.preventDefault();this.toggleClip(b);}));
      this.querySelectorAll('.psr__photo--video video').forEach(v=>{this.listen(v,'play',()=>this.syncClip(v));this.listen(v,'pause',()=>this.syncClip(v));});
      const first=this.querySelector('[data-gallery-panel]:not([hidden])');if(first)this.showPhoto(first.id);
      this.observePurchase();
      if(this.kb())setTimeout(()=>{ if(!this.kbReady())this._kbGaveUp=true; },8000);
      this.setAttribute('data-enhanced', 'true');
    }
    /* Free-gift card. Source of truth = the bundle app's own rendered offer (selected deal).
       The card shows only if the selected deal visibly contains THIS gift product (link to
       /products/<gift handle>), labelled free, and no paid add-on. Otherwise, or once the shopper
       opens "See bundle options", the app's own widget is shown. No app events or private APIs. */
    setupGift() {
      this.gift=this.querySelector('[data-gift]');
      if(!this.gift)return;
      this.offersBtn=this.querySelector('[data-offers-open]');
      if(this.offersBtn)this.listen(this.offersBtn,'click',()=>this.openOffers());
      const check=()=>this.syncGift();
      this._giftMo=new MutationObserver(check);
      this._giftMo.observe(this.form||this,{subtree:true,childList:true,attributes:true,attributeFilter:['class','hidden','style']});
      this._observers.push(this._giftMo);
      check();
    }
    syncGift() {
      const kb=this.form?.querySelector('kaching-bundle');
      const sel=kb?.querySelector('.kaching-bundles__bar--selected');
      const ok=!this._offersOpen && !!sel && !sel.querySelector('.kaching-bundles__upsell') &&
        [...sel.querySelectorAll('.kaching-bundles__free-gift')].some(g=>this.isOurGift(g));
      if(this.gift.hidden!==!ok)this.gift.hidden=!ok;
      this.classList.toggle('psr--gift-ready',ok);
      if(kb){ if(ok){ if(!kb.hasAttribute('inert'))kb.setAttribute('inert',''); } else if(kb.hasAttribute('inert'))kb.removeAttribute('inert'); }
      if(this.offersBtn){ const show=ok && kb.querySelectorAll('.kaching-bundles__bar').length>1; if(this.offersBtn.hidden!==!show)this.offersBtn.hidden=!show; }
    }
    isOurGift(g) {
      const handle=this.gift?.dataset.giftHandle;
      if(!handle||g.hidden||g.closest('[hidden]'))return false;
      const a=g.querySelector('a[href]');let path='';
      try{path=a?new URL(a.getAttribute('href'),location.href).pathname.replace(/\/$/,''):'';}catch(err){return false;}
      if(!path.endsWith('/products/'+handle))return false;
      const visible=typeof g.checkVisibility==='function'?g.checkVisibility({opacityProperty:true,visibilityProperty:true}):getComputedStyle(g).display!=='none';
      return visible && /\bfree\b/i.test(g.textContent||'');
    }
    openOffers() {
      this._offersOpen=true;this.classList.add('psr--offers-open');this.syncGift();
      const kb=this.form?.querySelector('kaching-bundle');
      const sel=kb?.querySelector('.kaching-bundles__bar--selected');
      const target=sel&&['[role="radio"]','[tabindex]:not([tabindex="-1"])','input'].map(q=>sel.querySelector(q)).find(Boolean);
      target?.focus({preventScroll:false});
    }
    setupReviews() {
      const btn=this.querySelector('[data-reviews-more]'), grid=this.querySelector('.psr__review-grid');
      if(!btn||!grid)return;
      grid.classList.add('is-collapsible');btn.hidden=false;
      this.listen(btn,'click',()=>{const open=grid.classList.toggle('is-open');btn.setAttribute('aria-expanded',String(open));btn.textContent=open?'Show fewer featured reviews':btn.dataset.label;});
      btn.dataset.label=btn.textContent;
    }
    toggleClip(btn) {
      const v=btn.closest('figure')?.querySelector('video');if(!v)return;
      if(v.paused){v.play().catch(()=>{});}else{v.pause();}
    }
    syncClip(v) {
      const b=v.closest('figure')?.querySelector('[data-clip-toggle]');if(!b)return;
      const playing=!v.paused;b.setAttribute('aria-pressed',String(playing));b.setAttribute('aria-label',playing?'Pause clip':'Play clip');
      const i=b.querySelector('[data-clip-icon]');if(i)i.textContent=playing?'❚❚':'▶';
    }
    disconnectedCallback() {
      this._abort?.abort();
      this._observers?.forEach(o => o.disconnect());
      this.querySelectorAll('video').forEach(v => v.pause());
      this._ready = false;
    }
    listen(target, type, fn, capture=false) { target?.addEventListener(type, fn, {signal:this._abort.signal, capture}); }
    onClick(e) {
      const thumb = e.target.closest('[data-gallery-to]');
      if (thumb && this.contains(thumb)) { e.preventDefault(); this.showPhoto(thumb.dataset.galleryTo); }
      const q = e.target.closest('[data-qty-change]');
      if(q && this.qty) {
        const step = Number(this.qty.step) || 1;
        const min = Number(this.qty.min) || 1;
        const max = this.qty.max ? Number(this.qty.max) : Infinity;
        const current = Number(this.qty.value) || min;
        this.qty.value = String(Math.max(min, Math.min(max, current + Number(q.dataset.qtyChange)*step)));
        this.qty.dispatchEvent(new Event('change', {bubbles:true}));
      }
      const tab=e.target.closest('[data-tab]');
      if(tab) this.selectTab(tab);
      const watch=e.target.closest('[data-watch]');
      if(watch) {
        const film=this.querySelector('[data-film]');
        if(film) {
          e.preventDefault();
          film.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
          const video=film.querySelector('video');
          if(video){ video.focus({preventScroll:true}); video.play().catch(()=>{}); }
        }
      }
      if(e.target.closest('[data-close-preview]')) this.dialog?.close();
    }
    onKeys(e) {
      const tab=e.target.closest('[data-tab]');
      if(tab && ['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) {
        e.preventDefault();
        const tabs=[...tab.closest('[data-tabs]').querySelectorAll('[data-tab]')];
        let index=tabs.indexOf(tab);
        index=e.key==='Home'?0:e.key==='End'?tabs.length-1:(index+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;
        this.selectTab(tabs[index]);tabs[index].focus();
      }
      const thumb=e.target.closest('[data-gallery-to]');
      if(thumb && ['ArrowLeft','ArrowRight'].includes(e.key)) {
        e.preventDefault();
        const thumbs=[...this.querySelectorAll('[data-gallery-to]')];
        const next=thumbs[(thumbs.indexOf(thumb)+(e.key==='ArrowRight'?1:-1)+thumbs.length)%thumbs.length];
        this.showPhoto(next.dataset.galleryTo);next.focus();
      }
    }
    onChange(e) {
      if(e.target===this.variant) this.updateVariant();
      if(e.target===this.qty) this.updateQtyButtons();
    }
    showPhoto(id) {
      const panels=[...this.querySelectorAll('[data-gallery-panel]')];
      if(!panels.some(p=>p.id===id))return;
      panels.forEach(p=>p.hidden=p.id!==id);
      panels.forEach(p=>{const v=p.querySelector('video');if(!v)return;if(p.id===id&&!matchMedia('(prefers-reduced-motion: reduce)').matches){v.play().catch(()=>{});}else{v.pause();}});
      const stage=this.querySelector('.psr__stage');const active=panels.find(p=>p.id===id);if(stage)stage.dataset.cover=String(!!active?.classList.contains('psr__photo--cover'));
      this.querySelectorAll('[data-gallery-to]').forEach(t=>{
        if(t.dataset.galleryTo===id)t.setAttribute('aria-current','true');
        else t.removeAttribute('aria-current');
      });
      const count=this.querySelector('[data-gallery-count]');
      if(count)count.textContent=`${panels.findIndex(p=>p.id===id)+1} / ${panels.length}`;
    }
    selectTab(tab) {
      const group=tab.closest('[data-tab-group]');
      if(!group)return;
      group.querySelectorAll('[data-tab]').forEach(t=>{
        const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;
      });
      group.querySelectorAll('[data-tab-panel]').forEach(p=>p.hidden=p.id!==tab.getAttribute('aria-controls'));
    }
    updateVariant() {
      const option=this.variant?.selectedOptions?.[0];
      if(!option){this.updateQtyButtons();return;}
      const available=option.dataset.available==='true';
      this._available=available;
      this.querySelectorAll('[data-price-output]').forEach(p=>p.textContent=option.dataset.price || '');
      this.querySelectorAll('[data-compare-output]').forEach(p=>{p.textContent=option.dataset.compare||'';p.hidden=!option.dataset.compare;});
      this.querySelectorAll('[data-save-output]').forEach(p=>{p.textContent=option.dataset.save||'';p.hidden=!option.dataset.save;});
      if(this._buyState==='idle')this.querySelectorAll('[data-add-label]').forEach(p=>p.textContent=available?'Add to cart':'Sold out');
      this.querySelectorAll('[data-add-button]').forEach(b=>b.disabled=!available);
      if(this.qty){
        this.qty.min=option.dataset.min||'1';this.qty.step=option.dataset.step||'1';
        if(option.dataset.max)this.qty.max=option.dataset.max;else this.qty.removeAttribute('max');
        const min=Number(this.qty.min), step=Number(this.qty.step), current=Number(this.qty.value)||min;
        this.qty.value=String(Math.max(min,min+Math.floor((current-min)/step)*step));
        if(this.qty.max && Number(this.qty.value)>Number(this.qty.max))this.qty.value=this.qty.max;
      }
      const rule=this.querySelector('[data-qty-rule]');
      if(rule){
        const min=Number(option.dataset.min||1), step=Number(option.dataset.step||1), max=option.dataset.max;
        rule.textContent=`Minimum ${min}${step>1?` · increments of ${step}`:''}${max?` · maximum ${max}`:''}.`;
        rule.hidden=min===1 && step===1 && !max;
      }
      this.updateQtyButtons();
      /* Native select remains the submission source. No hardcoded variant or cart URL. */
    }
    updateQtyButtons() {
      if(!this.qty)return;
      const n=Number(this.qty.value), min=Number(this.qty.min)||1, max=this.qty.max?Number(this.qty.max):Infinity;
      this.querySelectorAll('[data-qty-change]').forEach(b=>b.disabled=Number(b.dataset.qtyChange)<0?n<=min:n>=max);
    }
    /* ---------- Purchase path ----------
       One path for every Add to cart (form button, sticky bar, final CTA):
       - Outside buttons are routed to the form's own button.
       - If the bundle app's widget is on the page but still loading, wait for it (max 4 s) so the free
         gift is never skipped; if it never loads, fall back to the native product form (radar only;
         the gift card is not shown in that case, so nothing is promised).
       - Whoever submits owns the request: the app (observed on the store: it cancels the first submit,
         adds the gift via /cart/add.js, then re-submits the form so the radar is added natively; that
         follow-up submit is always let through) or the native form. The section only shows progress, blocks repeat clicks and
         reports a confirmed error (Resource Timing status, where the browser exposes it) or an unknown
         result after 10 s. Nothing is ever resubmitted automatically. */
    kb(){return this.form?.querySelector('kaching-bundle')||null;}
    kbReady(){const k=this.kb();return !!(k&&k.getAttribute('data-initialized')==='true'&&k.querySelector('.kaching-bundles__bar'));}
    waitForKb(ms=4000){
      return new Promise(resolve=>{
        if(this.kbReady())return resolve(true);
        const t0=Date.now();
        const tick=()=>{ if(this.kbReady())return resolve(true); if(Date.now()-t0>=ms)return resolve(false); this._kbPoll=setTimeout(tick,100); };
        tick();
      });
    }
    onAddClick(e) {
      const btn=e.target.closest('[data-add-button]');
      if(!btn||!this.form||btn.disabled)return;
      const main=this.form.querySelector('[data-add-button]');
      if(this._buyState==='app' && btn===main && !e.isTrusted){ this._appFollowUp=true; return; }   // the app's own follow-up click
      if(this._buyState!=='idle'){ e.preventDefault(); e.stopImmediatePropagation(); return; }
      if(!main||main.disabled)return;
      if(btn!==main)this._funnelFrom=btn;
      if(this.kb() && !this.kbReady() && !this._kbGaveUp){
        e.preventDefault(); e.stopImmediatePropagation();
        this.setBusy('waiting');
        this.waitForKb().then(ok=>{ if(!ok)this._kbGaveUp=true; this.setBusy('idle'); main.click(); });
        return;
      }
      if(btn!==main){ e.preventDefault(); e.stopImmediatePropagation(); main.click(); return; }
      this._sawSubmit=false;
      setTimeout(()=>{ if(this._buyState==='idle' && !this._sawSubmit && this.kbReady() && !this._isPreview) this.startApp(); },0);
    }
    onSubmit(e) {
      this._sawSubmit=true;
      if(!this.form?.checkValidity())return;
      if(this._isPreview) {
        e.preventDefault();
        this._dialogTrigger=this._funnelFrom || e.submitter || this.form.querySelector('[data-add-button]');this._funnelFrom=null;
        const cents=Number(this.variant?.selectedOptions?.[0]?.dataset.cents||0)*Number(this.qty?.value||1);const cur=this.dataset.currency||'USD';
        const line=this.querySelector('[data-preview-summary]');
        if(line)line.textContent=`${this.qty?.value||1} × Speed Radar Gun 2.0 · ${new Intl.NumberFormat(this.dataset.locale||'en-US',{style:'currency',currency:cur,currencyDisplay:'narrowSymbol'}).format(cents/100)} ${cur}`;
        this.dialog?.showModal();this.updateSticky();return;
      }
      if(this._buyState==='app'){
        // The bundle app's own follow-up submit (it adds the gift via /cart/add.js, then submits the
        // radar natively). Let it through and wait for the page to leave.
        this._appFollowUp=true; clearTimeout(this._buyTimer);
        this._buyTimer=setTimeout(()=>this.endBusy('unknown'),10000);
        return;
      }
      if(this._buyState!=='idle'){e.preventDefault();return;}
      this._funnelFrom=null;
      this.setBusy('native');
      setTimeout(()=>{
        if(e.defaultPrevented){ this.startApp(); return; }   // another script took over the submit
        this.clearBuyTimers();
        this._buyTimer=setTimeout(()=>this.endBusy('unknown'),10000);
      },0);
    }
    startApp(){
      this._funnelFrom=null;
      this._appFollowUp=false;
      this.setBusy('app');
      this.clearBuyTimers();
      const since=performance.now();
      try{
        this._buyObs=new PerformanceObserver(list=>{
          list.getEntries().forEach(en=>{
            if(en.startTime<since-50||!/\/cart\/add(\.js)?(\?|$)/.test(new URL(en.name,location.href).pathname+'?'))return;
            const st=en.responseStatus;
            if(typeof st==='number'&&st>=400){ this.endBusy('error'); }
            else if(typeof st==='number'&&st>=200&&!this._appFollowUp){ clearTimeout(this._buyTimer); this._buyTimer=setTimeout(()=>{ if(!this._appFollowUp)this.endBusy(null); },3000); }
          });
        });
        this._buyObs.observe({type:'resource',buffered:false});
      }catch(err){}
      this._buyTimer=setTimeout(()=>this.endBusy('unknown'),10000);
    }
    clearBuyTimers(){clearTimeout(this._buyTimer);clearTimeout(this._kbPoll);try{this._buyObs?.disconnect();}catch(err){}this._buyObs=null;}
    endBusy(kind){
      this.clearBuyTimers();
      if(this._buyState==='idle'&&!kind)return;
      this.setBusy('idle');
      if(kind)this.cartMsgs.forEach(m=>m.hidden=m.dataset.cartMsg!==kind);
    }
    setBusy(state){
      this._buyState=state;
      const busy=state!=='idle';
      this.classList.toggle('psr--busy',busy);
      if(busy)this.cartMsgs.forEach(m=>m.hidden=true);
      if(busy)this.form?.setAttribute('aria-busy','true');else this.form?.removeAttribute('aria-busy');
      const label=state==='waiting'?'Loading offer…':busy?'Adding…':(this._available===false?'Sold out':'Add to cart');
      this.querySelectorAll('[data-add-label]').forEach(p=>p.textContent=label);
      this.querySelectorAll('[data-add-button]').forEach(b=>{ if(busy)b.setAttribute('aria-disabled','true'); else b.removeAttribute('aria-disabled'); });
    }
    observePurchase() {
      if(!('IntersectionObserver' in window) || !this.sticky)return;
      const buy=this.querySelector('[data-buy-panel]'), final=this.querySelector('[data-final]');
      if(buy){const o=new IntersectionObserver(([entry])=>{this._pastBuy=entry.boundingClientRect.bottom<0;this.updateSticky();});o.observe(buy);this._observers.push(o);}
      if(final){const o=new IntersectionObserver(([entry])=>{this._atFinal=entry.isIntersecting;this.updateSticky();},{threshold:0.05});o.observe(final);this._observers.push(o);}
    }
    updateSticky(){
      if(!this.sticky)return;
      const visible=this.mediaQuery.matches && this._pastBuy && !this._atFinal && !this.dialog?.open;
      this.sticky.hidden=!visible;
      this.dataset.stickyVisible=String(visible);
    }
  }
  customElements.define('potent-speed-radar',PotentSpeedRadar);
})();
